import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  DataLabel,
  DataLabelValue,
} from '../../../Components/Common';
import { AddressLabelDisplayMapping } from '../../../Utility/sanitizers';
import CloseButtonSmall from 'src/Components/Common/Svg/CloseButtonSmall';
import './FibreAddressLine.css';

const FibreAddressLineC = ({ label, onValueSave, value, ...props }) => {

  const [isEditMode, setEditMode] = useState(false);
  const [newUnit, setNewUnit] = useState(value || '');
  const [newBuilding, setNewBuilding] = useState('');

  const handleSave = async () => {

    if (newUnit !== '') {
      await onValueSave('unitNumber', newUnit);
    }
    if (newBuilding !== '') {
      onValueSave('buildingName', newBuilding);
    }
    setEditMode(false);
  };

  return (
    <div className="fibre-address-line" {...props}>
      <DataLabel dataLabel={AddressLabelDisplayMapping[label]} />

      { isEditMode
          ? <div className="popup-main-container">
              <div className="popup-container">
                <div className="address-line-cancel-icon-container">
                  <span
                    className="address-line-action"
                    onClick={() => setEditMode(false)}
                  >
                    <CloseButtonSmall />
                  </span>
                </div>

                <div className="address-line-heading-container">
                  Review installation address
                </div>

                <div className="address-line-sub-heading-container">
                  Please provide your unit number and complex/building name.
                </div>

                <div className="address-editor-container">

                  <div className="editor-item">
                    <label className='address-editor-labels'>Unit no.</label>
                    <input
                      className='address-item-input'
                      type="text"
                      onChange={(e) => setNewUnit(e.target.value)}
                      value={newUnit}
                      placeholder="#"
                      maxLength={label === 'buildingName' ? 30 : null}
                    />
                  </div>

                  <div className="editor-item-complex">
                    <label className='address-editor-labels'>{AddressLabelDisplayMapping.buildingName}</label>
                    <input
                      className='address-item-input'
                      type="text"
                      onChange={(e) => setNewBuilding(e.target.value)}
                      placeholder="Enter complex/building number"
                      value={newBuilding}
                    />
                  </div>

                </div>

                <div className="editor-actions">
                  <button className="address-line-save-button" onClick={handleSave}>
                    Save
                  </button>
                </div>

              </div>
            </div>

          : <div className={label === 'unitNumber' || label === 'buildingName'
            ? 'address-line-modified'
            : ''
          }
            onClick={label === 'unitNumber' || label === 'buildingName'
              ? () => setEditMode(true)
              : undefined}>

            {
              value !== '' && (label === 'unitNumber' || label === 'buildingName')
                ? <DataLabelValue dataLabelValue={value} />
                : value === '' && (label === 'unitNumber' || label === 'buildingName')
                  ? <label className="line-value-placeholder"> Add {AddressLabelDisplayMapping[label]}

                  </label>
                  : <DataLabelValue dataLabelValue={value} />
            }

          </div>
      }

    </div>
  );
};


FibreAddressLineC.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onValueSave: PropTypes.func,
};

export const FibreAddressLine = FibreAddressLineC;
